var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        centered: "",
        "hide-footer": "",
        id: "createCfContactModal",
        title: "New " + _vm.modalTitle
      },
      on: { shown: _vm.focusMyElement }
    },
    [
      _c("ValidationObserver", {
        ref: "form",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("First Name")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            ref: "focusThis",
                            attrs: {
                              type: "text",
                              "lazy-formatter": "",
                              formatter: _vm.Format.titleCase
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.first_name,
                              callback: function($$v) {
                                _vm.first_name = $$v
                              },
                              expression: "first_name"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Last Name")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              "lazy-formatter": "",
                              formatter: _vm.Format.titleCase
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.last_name,
                              callback: function($$v) {
                                _vm.last_name = $$v
                              },
                              expression: "last_name"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Title")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              "lazy-formatter": "",
                              formatter: _vm.Format.titleCase
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.position,
                              callback: function($$v) {
                                _vm.position = $$v
                              },
                              expression: "position"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.deliverableContactCompanyLabel(
                                  _vm.deliverableDetail.deliverable_template_id
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              "lazy-formatter": "",
                              formatter: _vm.Format.titleCase
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.company_name,
                              callback: function($$v) {
                                _vm.company_name = $$v
                              },
                              expression: "company_name"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "email",
                              "lazy-formatter": "",
                              formatter: _vm.Format.email
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.email_address,
                              callback: function($$v) {
                                _vm.email_address = $$v
                              },
                              expression: "email_address"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Phone")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              type: "text",
                              "lazy-formatter": "",
                              formatter: _vm.Format.phone
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.saveContactFn.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [_vm._v("Region")]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: { options: _vm.allRegions, multiple: false },
                            model: {
                              value: _vm.region,
                              callback: function($$v) {
                                _vm.region = $$v
                              },
                              expression: "region"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.cfChildren, function(obj, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "col-md-6" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", [_vm._v(_vm._s(obj.label))]),
                              _vm._v(" "),
                              obj.field_type == "select"
                                ? _c("multiselect", {
                                    attrs: {
                                      options: _vm.getOptions(obj.value_set),
                                      multiple: !!obj.is_multiple,
                                      label: "name",
                                      "track-by": "slug",
                                      "show-labels": false,
                                      "allow-empty": false,
                                      "close-on-select": true
                                    },
                                    on: { select: _vm.selectRole },
                                    model: {
                                      value: _vm.selectedValues[obj.field_key],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectedValues,
                                          obj.field_key,
                                          $$v
                                        )
                                      },
                                      expression:
                                        "selectedValues[obj.field_key]"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.saveContactFn }
                          },
                          [_vm._v("Add")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showErrorAlert,
                            expression: "showErrorAlert"
                          }
                        ],
                        staticClass: "row"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col" },
                          [
                            _c(
                              "b-alert",
                              {
                                attrs: { variant: "danger" },
                                model: {
                                  value: _vm.showErrorAlert,
                                  callback: function($$v) {
                                    _vm.showErrorAlert = $$v
                                  },
                                  expression: "showErrorAlert"
                                }
                              },
                              [
                                _vm._v(
                                  "There is a problem with the information entered\n            above."
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }